import axios from "axios"
import UsuarioService from "./UsuarioService"

const controller = "/app"

const AppService = {
    activarOpcion: (opcId) => {
        return opcId && UsuarioService.getUsuario().opciones
            ? UsuarioService.getUsuario().opciones.includes(opcId)
            : false
    },
    /**
     * este metodo debería deprecarse...
     */
    getData: async (request) => {
        const { data } = await axios.post(`${controller}/getData`, request)
        return data
    },
}

export default AppService